<template>
  <Portal to="app-popup">
    <PopupBaseApprovalDetail
      :label="label"
      @close="$router.back()"
      @approveMethod="approveAction" 
      :showApproveButton="showApproveButton" 
      :approveButtonTitle="approveButtonTitle" 
      :approveButtonVariant="approveButtonVariant" 
      @rejectMethod="rejectAction" 
      :showRejectButton="showRejectButton" 
      :rejectButtonTitle="rejectButtonTitle" 
      :rejectButtonVariant="rejectButtonVariant"
      @revisionMethod="revisionAction" 
      :showRevisionButton="showRevisionButton" 
      :revisionButtonTitle="revisionButtonTitle" 
      :revisionButtonVariant="revisionButtonVariant"
      :isBusy="isBusy"
      :showApprovalHistoryButton="showApprovalHistoryButton"
      :approvalInstanceId="approvalInstanceId"
      :okTitle="okTitle"
      :showLeftIcon="showLeftIcon"
      :leftIcon="leftIcon"
      @hideMethod="onHidden"
    >
      <slot name="backdrop" slot="backdrop"/>
      <slot/>
      <template #modal-left-button>
        <slot name="modal-left-button"></slot>
      </template>
    </PopupBaseApprovalDetail>
  </Portal>
</template>

<script>
import PopupBaseApprovalDetail from './PopupBaseApprovalDetail.vue';

export default {
  name: 'PopupRouterViewDetail',
  props: {
    label: {
      required: true,
      type: String,
    },
    copyDataMethod: {},
    isShowCopyData: {
      type: Boolean,
      default: true
    },
    okTitle: {
      default: 'Close',
      type: String,
    },
    cancelTitle: {
      default: 'Copy Data',
      type: String,
    },
    okVariant: {
      default: 'success',
      type: String,
    },
    cancelVariant: {
      default: 'secondary',
      type: String,
    },
    isBusy: {
      default: false,
      type: Boolean,
    },
    approveMethod: {},
    showApproveButton: {
      type: Boolean,
      default: true
    },
    approveButtonTitle: {
      default: 'Approve Request',
      type: String,
    }, 
    approveButtonVariant: {
      default: 'success',
      type: String,
    },
    rejectMethod:{},
    showRejectButton: {
      type: Boolean,
      default: true
    },
    rejectButtonTitle: {
      default: 'Reject Request',
      type: String,
    },
     rejectButtonVariant: {
      default: 'warning',
      type: String,
    },
    revisionMethod:{},
    showRevisionButton: {
      type: Boolean,
      default: true
    },
    revisionButtonTitle: {
      default: 'Revise Request',
      type: String,
    },
     revisionButtonVariant: {
      default: 'default',
      type: String,
    },
    showApprovalHistoryButton: {
      type: Boolean,
      default: true
    },
    approvalInstanceId: {
      value: [Number, String]
    },
    showLeftIcon: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      default: 'add-icon.png',
      type: String,
    },
  },
  components: {
    PopupBaseApprovalDetail,
  },
  methods : {
    approveAction(modalEvent, emit) {
      this.$emit("approveMethod", modalEvent, emit);
    },
    rejectAction(modalEvent, model) {
      this.$emit("rejectMethod", modalEvent);
    },
    revisionAction(modalEvent, model) {
      this.$emit("revisionMethod", modalEvent);
    },
    onHidden() {
      this.$emit("onHideMethod");
    }
  }
};
</script>